export var ProductUpdateRole;
(function (ProductUpdateRole) {
    ProductUpdateRole["Source"] = "source";
    ProductUpdateRole["Target"] = "target";
    ProductUpdateRole["DeviceAction"] = "deviceAction";
})(ProductUpdateRole || (ProductUpdateRole = {}));
export var DeviceAction;
(function (DeviceAction) {
    DeviceAction["Return"] = "Retur til lager";
    DeviceAction["Transfer"] = "Omregistrer enhet";
})(DeviceAction || (DeviceAction = {}));
